import { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';
import { mapPersonaToPickerOption } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.utils';
import { EditConversationPayload } from '@sdk/messages/types/apiTypes';
import { FormMapping } from '@shopify/react-form';

import { ConversationEditFields } from '@web/conversations/ConversationEdit/conversationEdit.types';

export const getPickerPersonas = (personaIds: number[], personasDict: PersonasDict) => {
  return personaIds
    .map((id) => personasDict[id] || null)
    .filter(Boolean)
    .map(mapPersonaToPickerOption);
};

export const getConversationEditPayload = (
  id: ID,
  formFields: FormMapping<ConversationEditFields, 'value'>
): EditConversationPayload => {
  const { members, name, restricted, restrictedToUsers } = formFields;
  return {
    id,
    conversation: {
      name,
      personas: members.map(({ id }) => id),
      restricted,
      restrictedToPersonas: restrictedToUsers.map(({ id }) => id),
    },
  };
};
